import React, { useState } from "react";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import {
  TextField,
  Typography,
  Button,
  Box,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Modal,
  Fade
} from "@mui/material";
import classes from "./VendorInvite.module.css";
import { useSelector } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import deletePopupImg from "../../../assets/images/png/Group 2@2x.png";

const VendorInvite = () => {
  const loginData = useSelector((state) => state.loginData.value);
  const [buyer_token] = useState(loginData?.user?.token);
  const Datas = useSelector((state) => state.loginData.value);

  const [vendorName, setVendorName] = useState("");
  const [vendorEmail, setVendorEmail] = useState("");
  const [vendorMobile, setVendorMobile] = useState("");
  const [securityamount, setSecurityAmount] = useState("");
  const [file, setFile] = useState(null);
  const [response, setResponse] = useState(null);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogHeader, setDialogHeader] = useState("");

  const [vendorType, setVendorType] = useState("Vendor");
  const [dragging, setDragging] = useState(false);

  // ==== VENDOR LIMIT GUARD STATES (Same as VendorsTab) ====
  const [limitPopupOpen, setLimitPopupOpen] = useState(false);
  const [popupHeroText, setPopupHeroText] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [popupImage, setPopupImage] = useState(deletePopupImg);

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // vendor limit
  const vendorPlanLimit = Datas?.vendor_count ?? 0;


  const getTotalVendors = async () => {
    try {
      const res = await axios.post(
        API_ENDPOINT.get_all_vendor,
        { org_token: buyer_token, page_number: 1 },
        {
          headers: {
            Authorization: `Bearer ${loginData?.auth_token}`,
          },
        }
      );

      console.log("Vendor API raw response:", res.data);


      const totalVendors =
        Array.isArray(res.data?.users) ? res.data.users.length : 0;


      return totalVendors;
    } catch (error) {
      console.error("Error fetching vendor count:", error);
      return 0;
    }
  };

  // Guard check: stop invite if limit reached
  const guardLimitAndShow = async () => {
    if (vendorPlanLimit === 0) return false; // no limit set

    const totalVendors = await getTotalVendors();


    if (vendorPlanLimit > 0 && totalVendors >= vendorPlanLimit) {
      setPopupHeroText("Vendor Limit Reached");
      setPopupMessage(
        `Your account can have up to ${vendorPlanLimit} vendors. Current vendors: ${totalVendors}.`
      );
      setPopupImage(deletePopupImg);
      setLimitPopupOpen(true);
      return true;
    }
    return false;
  };

  //  Handle invite
  const handleInvite = async (e) => {
    e.preventDefault();

    const atLimit = await guardLimitAndShow();
    if (atLimit) {
      console.log("Invite stopped due to vendor limit reached.");
      return;
    }

    if (vendorEmail && !isValidEmail(vendorEmail)) {
      alert("Please enter a valid email address.");
      return;
    }

    const formData = new FormData();

    if (file) {
      formData.append("vendor_file", file);
      formData.append("buyer_token", buyer_token);
    } else if (vendorEmail && vendorName) {
      formData.append("vendor_mail", vendorEmail);
      formData.append("vendor_name", vendorName);
      formData.append("vendor_mobile", vendorMobile);
      formData.append("securityamount", securityamount);
      formData.append("vendorType", vendorType);
      formData.append("buyer_token", buyer_token);
    } else {
      alert("Please fill vendor details or upload a file.");
      return;
    }

    try {
      const res = await axios.post(API_ENDPOINT.invite_vendor, formData, {
        headers: {
          Authorization: `Bearer ${loginData?.auth_token}`,
        },
      });

      console.log("✅ Invite Response:", res.data);

      if (res.data?.success || res.data?.message) {
        setVendorName("");
        setVendorEmail("");
        setVendorMobile("");
        setSecurityAmount("");
        setFile(null);
        setDialogOpen(true);
      } else {
        alert("Invite failed.");
      }
    } catch (err) {
      console.error("Invite Error:", err);
      alert("Error sending invite");
    }
  };


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFile(file);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    const file = event.dataTransfer.files[0];
    if (file) {
      setFile(file);
    }
  };

  const handleAmountChange = (e) => {
    const raw = e.target.value.replace(/,/g, "");
    if (!isNaN(raw)) {
      setSecurityAmount(Number(raw).toLocaleString("en-IN"));
    }
  };

  // Close limit popup - same as VendorsTab
  const handleCloseLimitPopup = () => {
    setLimitPopupOpen(false);
  };

  return (
    <div style={ { marginTop: "1rem" } }>
      <p
        style={ { fontSize: "2.4rem", fontWeight: "600", color: "#3a3a3c" } }
      >{ `${vendorType} Invite` }</p>

      <Box display="flex" alignItems="center" gap={ 2 }>
        <FormLabel
          component="legend"
          sx={ { fontSize: "14px", fontWeight: "bold", whiteSpace: "nowrap" } }
        >
          Select the Type
        </FormLabel>

        <RadioGroup
          row
          value={ vendorType }
          onChange={ (e) => setVendorType(e.target.value) }
          sx={ { fontSize: "14px" } }
        >
          <FormControlLabel
            value="Vendor"
            control={ <Radio /> }
            label={ <Typography sx={ { fontSize: "14px" } }>Vendor</Typography> }
          />
          <FormControlLabel
            value="Merchant"
            control={ <Radio /> }
            label={ <Typography sx={ { fontSize: "14px" } }>Merchant</Typography> }
          />
        </RadioGroup>
      </Box>

      { vendorType && (
        <>
          <Grid container spacing={ 2 } mb={ 2 }>
            <Grid item xs={ 3 }>
              <TextField
                label={ `${vendorType} Name` }
                fullWidth
                value={ vendorName }
                onChange={ (e) => setVendorName(e.target.value) }
                disabled={ file !== null }
                variant="outlined"
                sx={ {
                  "& .MuiInputBase-input": {
                    fontSize: "16px",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "12px",
                  },
                  "& .MuiInputLabel-shrink": {
                    fontSize: "14px",
                  },
                } }
              />
            </Grid>
            <Grid item xs={ 3 }>
              <TextField
                label={ `${vendorType} Email` }
                fullWidth
                type="email"
                value={ vendorEmail }
                onChange={ (e) => setVendorEmail(e.target.value) }
                disabled={ file !== null }
                variant="outlined"
                sx={ {
                  "& .MuiInputBase-input": {
                    fontSize: "16px",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "12px",
                  },
                  "& .MuiInputLabel-shrink": {
                    fontSize: "14px",
                  },
                } }
              />
            </Grid>
            <Grid item xs={ 3 }>
              <TextField
                label={ `${vendorType} Mobile` }
                fullWidth
                value={ vendorMobile }
                type="text"
                onChange={ (e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    setVendorMobile(value);
                  }
                } }
                disabled={ file !== null }
                variant="outlined"
                sx={ {
                  "& .MuiInputBase-input": {
                    fontSize: "16px",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "12px",
                  },
                  "& .MuiInputLabel-shrink": {
                    fontSize: "14px",
                  },
                } }
              />
            </Grid>

            <Grid item xs={ 3 }>
              <TextField
                label={ `${vendorType} Security Amount` }
                fullWidth
                value={ securityamount }
                type="text"
                onChange={ handleAmountChange }
                disabled={ file !== null }
                variant="outlined"
                sx={ {
                  "& .MuiInputBase-input": {
                    fontSize: "16px",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "12px",
                  },
                  "& .MuiInputLabel-shrink": {
                    fontSize: "14px",
                  },
                } }
              />
            </Grid>
          </Grid>

          <div>
            {/* File Upload Section */ }
            <Box mb={ 2 }>
              <div className={ classes.docField }>
                <div
                  className={ `${classes.fileUploadWrapper} ${dragging ? classes.drag_over : ""
                    }` }
                  onDragOver={ handleDragOver }
                  onDragLeave={ handleDragLeave }
                  onDrop={ handleDrop }
                >
                  <div className={ classes.file_upload }>
                    { !file ? (
                      <>
                        <label className={ classes.DocText }>
                          <span>Drag and drop file here</span>
                          <input
                            type="file"
                            accept=".csv,.xlsx"
                            style={ { display: "none" } }
                            onChange={ handleFileChange }
                            id="fileInput"
                          />
                          <p>(Supported format CSV/Excel)</p>
                        </label>
                        <button
                          onClick={ () =>
                            document.getElementById("fileInput").click()
                          }
                        >
                          Browse
                        </button>
                      </>
                    ) : (
                      <div
                        style={ {
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: "100px",
                        } }
                      >
                        <span>
                          { file.name } ({ (file.size / 1024).toFixed(2) } KB)
                        </span>
                        <button
                          onClick={ () => setFile(null) }
                          style={ {
                            background: "transparent",
                            border: "none",
                            color: "red",
                            cursor: "pointer",
                            fontWeight: "600",
                          } }
                        >
                          Remove
                        </button>
                      </div>
                    ) }
                  </div>
                </div>
              </div>
            </Box>

            <Button
              variant="outlined"
              style={ { marginBottom: "12px", fontSize: "12px" } }
              onClick={ () => {
                const csvContent = `${vendorType} Name,${vendorType} Email,${vendorType} Mobile,Security Amount\nExample ${vendorType.toLowerCase()},${vendorType.toLowerCase()}@example.com,9999999999,10000`;
                const blob = new Blob([csvContent], { type: "text/csv" });
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `sample_${vendorType}_invite.csv`;
                a.click();
              } }
            >
              Download Sample CSV
            </Button>
          </div>

          {/* Send Invite Button */ }
          <Button
            type="submit"
            onClick={ (e) => handleInvite(e) }
            variant="contained"
            color="primary"
            style={ { height: "4rem", fontSize: "12px" } }
            disabled={
              !file && // If no file, then check manual input
              (!vendorName.trim() ||
                !vendorEmail.trim() ||
                !isValidEmail(vendorEmail) ||
                vendorMobile.length !== 10)
            }
          >
            Send Invite
          </Button>
        </>
      ) }

      {/* Success Dialog */ }
      <Dialog
        open={ dialogOpen }
        onClose={ () => setDialogOpen(false) }
        PaperProps={ {
          sx: {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            maxHeight: "81vh",
            overflow: "auto",
          },
        } }
      >
        <DialogTitle sx={ { fontSize: "18px", fontWeight: 600 } }>
          <div style={ { display: "flex", alignItems: "center" } }>
            <CheckCircleIcon color="success" fontSize="large" />
            <span style={ { marginLeft: 6, fontWeight: 500 } }>
              Vendor Invitation sent successfully!
            </span>
          </div>
        </DialogTitle>
        <DialogContent>
          <Typography sx={ { fontSize: "14px" } }>
            The vendor has been notified via email.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={ () => setDialogOpen(false) }
            style={ { height: "4rem", fontSize: "12px", fontWeight: "600" } }
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* Vendor Limit Reached Popup - EXACT SAME AS VendorVendorsTab */ }
      <Modal open={ limitPopupOpen }>
        <Fade in={ limitPopupOpen }>
          <Box>
            <SuccessPopupDashboard
              popupImage={ popupImage }
              popupHeroText={ popupHeroText }
              popupDescription={ popupMessage }
              popBtn={ true }
              btnText={ "Okay" }
              buyerBtn={ true }
              buyerBtnOutline={ true }
              btnClick={ handleCloseLimitPopup }
            />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default VendorInvite;

